import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "./Logo";

export const LegalPage = ({ title, updated, testId, children }) => {
    useEffect(() => {
        window.__lenis?.scrollTo(0, { immediate: true });
        window.scrollTo(0, 0);
    }, []);

    return (
        <div data-testid={testId} className="min-h-screen">
            <header className="border-b border-white/10 bg-[#050505]/70 backdrop-blur-xl">
                <div className="mx-auto flex h-16 max-w-3xl items-center justify-between px-6">
                    <Link to="/" data-testid="legal-logo" className="flex items-center gap-2.5" aria-label="RedeemDeals home">
                        <Logo size={22} />
                        <span className="font-display text-lg font-medium tracking-tight text-white">RedeemDeals</span>
                    </Link>
                    <Link
                        to="/"
                        data-testid="back-to-home-link"
                        className="inline-flex items-center gap-2 text-sm text-white/60 transition-colors duration-200 hover:text-white"
                    >
                        <ArrowLeft size={15} />
                        Back to home
                    </Link>
                </div>
            </header>
            <main className="mx-auto max-w-3xl px-6 py-16 sm:py-20">
                <h1 className="font-display text-4xl font-medium tracking-tight text-white sm:text-5xl">{title}</h1>
                <p className="mt-3 text-sm text-white/40">Last updated: {updated}</p>
                <div className="mt-10 space-y-10">{children}</div>
            </main>
        </div>
    );
};

export const LegalSection = ({ title, children }) => (
    <section>
        <h2 className="font-display text-xl font-medium text-white">{title}</h2>
        <div className="mt-3 space-y-3 text-base leading-relaxed text-white/60">{children}</div>
    </section>
);
